<template>
  <div>
    <v-select
      :label="$t('addShooting.selectFormat')"
      v-model="selectedFormat"
      :items="formatTypes"
      @input="update"
    ></v-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SelectFormat',

  data() {
    return {
      selectedFormat: null,
      formatTypes: ['4/3', '16/9']
    }
  },

  computed: {
    ...mapState({
      format: (state) => state.newShooting.format
    })
  },

  methods: {
    update(val) {
      this.$store.commit('UPDATE_FORMAT', val)
    }
  }
}
</script>

<style lang="sass" scoped>
p
  text-align: center
  font-size: 16px
  color: rgba(0, 0, 0, 0.7)
</style>
